<div class="d-flex flex-column">
    <div mat-dialog-content class="dialog-content-pad-15">
        <h4 mat-dialog-title class="timeline-item-dialog-title">
            @switch(data.requestType){
                @case('MoodRequest'){
                    <i [ngClass]="'icon-smileys-'+data.item.mood" class="pe-2"></i> {{'add_comment_modal_title' | translate}} 
                }
            }
        </h4>
        
        @if(data.requestType === 'MoodRequest'){
            <mood-request-form [teamId]="data.teamId"
                               [item]="data.item"></mood-request-form>
        }
        <div mat-dialog-actions>
            <button type="button" class="btn btn-default" data-cy="user-request-modal-close" (click)="close()">
                {{'close' | translate}}
            </button>
            <button type="button" class="btn btn-primary" data-cy="user-request-modal-submit"
                    [disabled]="data.item.comment?.body?.length === 0"
                    (click)="save(data.item)">{{'Save' | translate }} 
                <i class="far fa-check"></i>
            </button>
        </div>
    </div>    
</div>